import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import PropTypes from 'prop-types';
import ClockPendingLottie from './components/ClockPendingLottie';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 99999;
  background: ${({ bgColor, theme: { color } }) => (bgColor ? color[bgColor] : '#fff')};
  width: 100vw;
`;
const skBouncedelay = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 40% {
    transform: scale(1.0);
  }
`;
const LoadingDot = styled.div`
  & > div {
    width: 12px;
    height: 12px;
    background-color: #04bbff;
    border-radius: 100%;
    display: inline-block;
    animation: ${skBouncedelay} 1.4s infinite ease-in-out both;
    margin: 4px;
    &:nth-child(1) {
      animation-delay: -0.32s;
    }
    &:nth-child(2) {
      animation-delay: -0.16s;
    }
  }
`;

const WrapperTtile = styled.div`
  background: linear-gradient(${({ theme: { color } }) => color.PLGradient.join(',')});
  padding: 0 24px 24px 24px;
`;

const MessageTitle = styled.div`
  ${({ theme }) => theme.typography.bodyLargeHighlight()}
  color: ${({ theme: { color } }) => color.white};
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('xs')} {
      max-width: 250px;
    }
  `}
`;

const MessageText = styled.p`
  ${({ theme }) => theme.typography.bodyLargeHighlight()}

  line-height: 20px;
  font-weight: normal;
  font-size: 16px;
  color: #000000;
  max-width: 250px;
  margin: 0 auto;
  padding: 16px;
`;

const MessageTextWrapper = styled.div`
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
`;

const MessageWrapper = styled.div`
  max-width: 600px;
  margin-bottom: 24px;
  background-color: white;
`;

const LoadingIcon = () => {
  return (
    <LoadingDot>
      <div />
      <div />
      <div />
    </LoadingDot>
  );
};

const FullPageSpinner = ({ op = '', bgColor = '', title = '', message = '', style }) => (
  <Wrapper data-testid="loading" opacity={op} bgColor={bgColor} style={style}>
    {message || title ? (
      <MessageTextWrapper>
        <MessageWrapper>
          <WrapperTtile>
            <ClockPendingLottie />
            <MessageTitle>{title}</MessageTitle>
          </WrapperTtile>
          <MessageText>{message}</MessageText>
        </MessageWrapper>
      </MessageTextWrapper>
    ) : (
      <LoadingIcon />
    )}
  </Wrapper>
);

FullPageSpinner.propTypes = {
  op: PropTypes.string,
  bgColor: PropTypes.string,
  style: PropTypes.any,
};

export default FullPageSpinner;
export { LoadingIcon };
